const getSpeed = (speed: number) => {
  switch (speed) {
    case 0: return 'Idle'
    case 13: return 'Stir'
    case 14: return 'Slow Stir'
    default: return speed
  }
}

export default getSpeed